<template lang="pug">
v-content
  v-container.fill-height(fluid="")
    v-row(align="center", justify="center")
      v-col(cols="12", sm="8", md="6")
        v-card.elevation-12
          v-toolbar(color="primary", dark, flat)
            v-toolbar-title Inicio Sesión
          .alert(v-if="messages_error_request")
            v-alert(border="top", color="red lighten-2", dark)
              ul
                li(v-for="message in messages_error_request") {{ message }}
          v-card-text
            ValidationObserver(ref="observer", v-slot="{ validate, reset }")
              v-form
                ValidationProvider(
                  v-slot="{ errors }",
                  name="Correo Electrónico",
                  rules="required|email"
                )
                  v-text-field(
                    label="Correo Electrónico",
                    type="text",
                    prepend-icon="fa-envelope",
                    v-model="credentials.email",
                    :error-messages="errors",
                    required
                  )
                ValidationProvider(
                  v-slot="{ errors }",
                  name="Contraseña",
                  rules="required|min:8"
                )
                  v-text-field(
                    label="Contraseña",
                    prepend-icon="fa-lock",
                    v-model="credentials.password",
                    :type="show_password ? 'text' : 'password'",
                    :append-icon="show_password ? 'fa-eye' : 'fa-eye-slash'",
                    @click:append="show_password = !show_password",
                    :error-messages="errors",
                    required
                  )
                v-checkbox(
                  v-model="remind_me",
                  label="Recuerdame",
                  color="secondary"
                )
            v-card-actions
              v-spacer
              v-btn(
                color="primary",
                @click="login",
                @keyup.enter="login",
                :loading="loading",
                :disabled="loading",
                outlined,
                block
              ) Ingresar
            v-divider
            v-card-text
              v-row(align="center", justify="center")
                v-btn.text-center(
                  color="primary",
                  text,
                  @click="show_forget_pass = !show_forget_pass"
                ) ¿Olvidaste tu Contraseña?
              v-row(
                v-show="show_forget_pass",
                align="center",
                justify="center"
              )
                v-col(cols="12", sm="12")
                  h4.text-center Ingresa tu email y te ayudaremos a recuperarla
                v-col(cols="12", sm="10")
                  ValidationObserver(
                    ref="forget",
                    v-slot="{ validate, reset }"
                  )
                    v-form
                      ValidationProvider(
                        v-slot="{ errors }",
                        name="Correo Electrónico",
                        rules="required|email"
                      )
                        v-text-field(
                          label="Correo Electrónico",
                          type="text",
                          prepend-icon="fa-envelope",
                          v-model="forget_pass_email",
                          :error-messages="errors",
                          required
                        )
                v-col(cols="12", sm="2")
                  v-btn(
                    color="secondary",
                    :loading="loading2",
                    :disabled="loading2",
                    @click="forget_password",
                    block
                  ) Enviar
            //-     v-btn(color='primary', to='/auth/signup', link, text) Registro
</template>

<script>
import authAPI from "@/api/auth";
import { required, email, min } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} no puede ser vacío",
});

extend("min", {
  ...min,
  message: "{_field_} no puede ser menor que {length} caracteres",
});

extend("email", {
  ...email,
  message: "Correo Electrónico debe ser válido",
});

export default {
  name: "Login",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      loading: false,
      loading2: false,
      remind_me: false,
      show_password: false,
      show_forget_pass: false,
      forget_pass_email: null,
      messages_error_request: null,
      credentials: {
        email: null,
        password: null,
      },
    };
  },
  methods: {
    async login() {
      this.messages_error_request = null;
      if (await this.$refs.observer.validate()) {
        this.loading = true;
        const response = await this.$store.dispatch("auth/signIn", {
          credentials: this.credentials,
          remind_me: true,
        });
        this.loading = false;
        if (response.status) {
          this.$router.replace("/");
        } else {
          this.messages_error_request = response.data;
        }
      }
    },
    async forget_password() {
      this.messages_error_request = null;
      if (await this.$refs.forget.validate()) {
        this.loading2 = true;
        const response = await authAPI.forgetPassword({
          email: this.forget_pass_email,
        });
        this.loading2 = false;
        if (response.status) {
          this.$swal({
            title:
              "Hemos enviado un correo electrónico para que puedas recuperrar tu contraseña",
            icon: "success",
          });
        } else {
          this.messages_error_request = response.data;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.alert {
  padding: 15px;
}
</style>

